import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/jyranians/zen-jyranian.svg'
import _imports_1 from '../../assets/jyranians/jyranian-clipboard-2.svg'
import _imports_2 from '../../assets/jyranians/jyranian-female-side-2.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-50b00b19"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "smart-callout-image-container" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  alt: "a wise zen jyranian called Apollo",
  class: "smart-jyranian",
  "data-test": "smart-callout-image"
}
const _hoisted_3 = { class: "smart-callout-box" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "smart-text",
  "data-test": "smart-callout-text"
}
const _hoisted_6 = {
  key: 2,
  class: "center-flex",
  style: {"flex-direction":"column"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"rgb(85, 85, 85)","font-size":"12px","text-align":"center","margin-top":"10px"} }, " If you've just edited a text box: please wait a moment before pressing this button. Gyre needs a few seconds to process your input. If nothing happens after pressing the button, please try it again. ", -1))
const _hoisted_8 = {
  key: 4,
  class: "smart-callout-image-container"
}
const _hoisted_9 = {
  key: 0,
  src: _imports_1,
  alt: "an older Jyranian with a clipboard called Emile",
  class: "smart-jyranian",
  "data-test": "smart-callout-image"
}
const _hoisted_10 = {
  key: 1,
  src: _imports_2,
  alt: "an energetic female Jyranian called Klara",
  class: "smart-jyranian",
  "data-test": "smart-callout-image"
}

import { computed, onMounted, ref, watch } from "vue";
import cms from "../../services/cms/cms";
import chat from "../../components/smart-scratchpad/chat";
import LoadingSpinner from "../loading-spinner.vue";
import { useCmsSessionStore } from "../../stores/useCmsSessionStore";
import pinia from "../../stores";
import processPromptVars, {
  getDataContext,
} from "../../components/smart-scratchpad/process-prompt-vars";
import { renderErrorMessageToClient } from "../smart-scratchpad/variable-error-helpers";
import { SmartJyranian } from "../../services/cms/cms-type-definitions";
import { Analytics } from "../../services/analytics/analytics";
import { csContext } from "../../services/cs-context";
import { AxiosError } from "axios";

import smartTextBoxStore from "../../stores/smart-text-box-store";


export default /*#__PURE__*/_defineComponent({
  __name: 'cms-smart-callout',
  props: {
    uid: {}
  },
  setup(__props: any) {

/* eslint-disable */
let cmsSessionStore = useCmsSessionStore(pinia());

const props = __props;
const text = ref<string>("");
const chatIsLoading = computed(() => text.value.length === 0);
const isManuallyTriggered = ref<boolean | null>(null);
const isLoaded = ref(false);

const prompt = ref<string>("");
const jyranian = ref<SmartJyranian>("Apollo");
const isStreaming = ref(false);

const hasRequiredData = computed(
  () =>
    cmsSessionStore.hasFinishedMapping.strengths ||
    (csContext.userDocument.hasCompletedFoundationsSession &&
      !window.location.href.includes("/foundations/remapping")),
);

const textBoxVersions = computed(() => smartTextBoxStore.$state.version);
const jyranianClass = computed(() => jyranian.value.toLowerCase());

let version = 0;
let dataContext: any = null;

watch(textBoxVersions, async () => {
  version++;

  if (!isManuallyTriggered.value) {
    await askPrompt();
  }
});

watch(hasRequiredData, async () => {
  if (hasRequiredData.value) {
    dataContext = getDataContext();

    if (!isManuallyTriggered.value) {
      await askPrompt();
    }
  }
});

async function askPrompt(bypassCache = false): Promise<void> {
  let activeVersion = version;
  isStreaming.value = true;
  text.value = "";

  if (prompt.value?.trim().length > 0 && hasRequiredData.value) {
    const { processed, errors } = await processPromptVars(prompt.value, dataContext);

    if (errors.length > 0) {
      text.value = renderErrorMessageToClient(errors);
      return;
    }

    Analytics.action("Ran Smart Callout", "SmartCalloutActions", {
      prompt: prompt.value,
      processed,
    });

    chat(
      processed,
      (content) => {
        if (activeVersion === version) {
          text.value = content.trim();
        }
      },
      bypassCache,
    )
      .then((message) => {
        Analytics.action("Completed Smart Callout", "SmartCalloutActions", {
          prompt: prompt.value,
          response: message.trim(),
        });
      })
      .catch((e) => {
        text.value = "Sorry, there was an error. Please refresh the page.";
        const error = e as AxiosError;
        const errorMessage = `${error.response?.status}: ${error.response?.statusText}`;
        Analytics.action("Failed Smart Callout", "SmartCalloutActions", {
          prompt: prompt.value,
          error: errorMessage,
        });
      })
      .finally(() => {
        isStreaming.value = false;
      });
  }
}

onMounted(async () => {
  const { data } = await cms.getByUid(
    "cms-smart-callout",
    props.uid ?? "smart-callout-solo-summary",
  );

  isManuallyTriggered.value = data.manually_triggered ?? false;
  prompt.value = data.prompt ?? data.example;
  jyranian.value = data.jyranian ?? "Apollo";
  dataContext = getDataContext();
  if (!isManuallyTriggered.value) {
    await askPrompt();
  }

  isLoaded.value = true;
});

return (_ctx: any,_cache: any) => {
  const _directive_markdown = _resolveDirective("markdown")!

  return (isLoaded.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["smart-callout-container", jyranianClass.value]),
        "data-test": "smart-callout"
      }, [
        _createElementVNode("div", _hoisted_1, [
          (jyranian.value === 'Apollo')
            ? (_openBlock(), _createElementBlock("img", _hoisted_2))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_3, [
          (isManuallyTriggered.value && !isStreaming.value && !chatIsLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = () => askPrompt(true)),
                  class: "btn btn-sm btn-default-reload center-flex",
                  style: {"z-index":"999999"}
                }, " Regenerate ")
              ]))
            : _createCommentVNode("", true),
          (!chatIsLoading.value)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, null, 512)), [
                [_directive_markdown, text.value]
              ])
            : (isManuallyTriggered.value && !isStreaming.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = () => askPrompt(false)),
                    class: "btn btn-sm btn-default-reload",
                    style: {"z-index":"999999"}
                  }, " Generate "),
                  _hoisted_7
                ]))
              : (chatIsLoading.value)
                ? (_openBlock(), _createBlock(LoadingSpinner, {
                    key: 3,
                    type: 'Dots',
                    size: "200px",
                    "data-test": "smart-callout-loading"
                  }))
                : _createCommentVNode("", true),
          (jyranian.value !== 'Apollo')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (jyranian.value === 'Emile')
                  ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                  : (jyranian.value === 'Klara')
                    ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                    : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})